import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import productBadgeMessages from 'i18n/productBadgeMessages'

function useProductLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const leFlashHotelProductLabel = intl.formatMessage(productBadgeMessages.limitedTimeLuxExclusiveLe)
    const flashHotelProductLabel = intl.formatMessage(productBadgeMessages.limitedTimeLuxExclusiveWl)
    const leTaoHotelProductLabel = intl.formatMessage(productBadgeMessages.luxPremiumCollectionLe)
    const taoHotelProductLabel = intl.formatMessage(productBadgeMessages.luxPremiumCollectionWl)
    const lmeHotelProductLabel = intl.formatMessage(productBadgeMessages.lastMinuteEscape)
    const leLppProductLabel = intl.formatMessage(productBadgeMessages.luxPartnerPropertyLe)
    const lppProductLabel = intl.formatMessage(productBadgeMessages.luxPartnerPropertyWl)
    const luxBundleLabel = intl.formatMessage(productBadgeMessages.bundleAndSave)
    const lePartner = intl.formatMessage(productBadgeMessages.luxTrustedPartner)
    const leExclusive = intl.formatMessage(productBadgeMessages.luxExclusive)

    return {
      leFlashHotelProductLabel,
      flashHotelProductLabel,
      leTaoHotelProductLabel,
      taoHotelProductLabel,
      lmeHotelProductLabel,
      leLppProductLabel,
      lppProductLabel,
      luxBundleLabel,
      lePartner,
      leExclusive,
    }
  }, [intl])
}

export default useProductLabels
